module.exports = __webpack_public_path__ + "assets/img/school.1280140b.png";